import {StyleSheet} from "aphrodite";
import * as React from "react";

import {addStyle, View} from "@khanacademy/wonder-blocks-core";
import {semanticColor, sizing} from "@khanacademy/wonder-blocks-tokens";
import {Heading} from "@khanacademy/wonder-blocks-typography";

const StyledFieldset = addStyle("fieldset");

interface Props {
    legendContent: React.ReactNode | string;
    children: React.ReactNode;
    testId?: string;
    id?: string;
    footer?: React.ReactNode;
    style?: React.CSSProperties;
    footerStyle?: React.CSSProperties;
}

export const Section: React.FC<Props> = ({
    legendContent,
    testId,
    id,
    children,
    footer,
    style,
    footerStyle,
}) => {
    const legend =
        typeof legendContent === "string" ? (
            <Heading tag="h2" size="large" weight="bold" style={styles.legend}>
                {legendContent}
            </Heading>
        ) : (
            legendContent
        );
    return (
        <View style={[styles.container, style]} role="region">
            <StyledFieldset
                id={id}
                data-testid={testId ?? "section"}
                style={styles.fieldset}
            >
                <legend>{legend}</legend>
                <View>{children}</View>
                {footer && (
                    <View style={[styles.footer, footerStyle]}>{footer}</View>
                )}
            </StyledFieldset>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        background: semanticColor.core.background.base.default,
        border: `1px solid ${semanticColor.core.border.neutral.subtle}`,
        borderRadius: sizing.size_080,
        padding: sizing.size_320,
        width: "100%",
        maxWidth: 800,
    },
    footer: {
        marginBlockStart: sizing.size_160,
    },
    legend: {
        marginBlockEnd: sizing.size_160,
    },
    fieldset: {
        // The browser's user agent stylesheet sets `min-inline-size` to
        // `min-content`,which can cause contents to overflow
        minInlineSize: 0,
    },
});
